<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between margin-bottom-sm ">
            <b class="page-title line-height">会员说明</b>
            <el-button v-if="user.isBranch" class="publish" round type="primary" @click="addClassify(false)"><i class="el-icon-edit"></i>添加分类
            </el-button>
        </div>
        <div class="page-list flex flex-direction align-center margin-top">
            <div class="item flex flex-direction margin-bottom-xs">
                <div class="header flex align-center justify-between padding-lr-sm">
                    <div class="title"><i class="el-icon-menu"></i>入会须知</div>
                    <div class="flex align-center">
                        <router-link class="margin-right-xs" to="/branch/setup/explainType/1/入会须知">
                            <el-button class="operate">{{user.isBranch? '编辑': '查看'}}</el-button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-for="(item,index) in lists" :key="index" class="item flex flex-direction margin-bottom-xs">
                <div class="header flex align-center justify-between padding-lr-sm">
                    <div class="title"><i class="el-icon-menu"></i>{{ item.typeName }}</div>
                    <div class="flex align-center">
                        <router-link v-if="user.isBranch" class="margin-right-xs" :to="`/branch/setup/explainArticle/${item.typeId}/0`">
                            <el-button class="operate">添加</el-button>
                        </router-link>
                        <el-button v-if="user.isBranch" class="operate" @click="addClassify(item)">编辑</el-button>
                        <el-button v-if="user.isBranch" class="operate" @click="deleteItem(item.typeId)">删除</el-button>
                    </div>
                </div>
                <div v-for="(child,position) in item.list" :key="position"
                     class="child flex align-center justify-between">
                    <div class="title">{{ child.title }}</div>
                    <div class="flex align-center">
                        <router-link  class="margin-right-xs" :to="`/branch/setup/explainArticle/${child.type}/${child.id}`">
                            <el-button class="operate">{{user.isBranch? '编辑': '查看'}}</el-button>
                        </router-link>
                        <el-button v-if="user.isBranch" class="operate" @click="deleteArticleItem(child.id)">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
<!--        <empty v-if="lists.length === 0" :type="0"/>-->
        <el-dialog
            :visible.sync="addDialogVisible"
            center
            class="dialog-container"
            title="分类编辑"
            width="30%">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="info width-100 margin-top"
                     labelPosition="left" labelWidth="100px">
                <el-form-item class="input-container" label="分类名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
                </el-form-item>
                <div class="dialog-footer flex align-center justify-around">
                    <el-button class="operate" @click="addDialogVisible = false">取消</el-button>
                    <el-button class="operate yellow" @click="submitForm('ruleForm')">提交</el-button>
                </div>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
import {createAndUpdateArticleType, delArticleType, getMemberClassifyList,delArticle} from "@/api/branch";

export default {
    name: "label",
    data() {
        return {
            lists: [],
            cur_id: '',
            ruleForm: {
                name: '',
            },
            rules: {
                name: [
                    {required: true, message: '请输入分类名称', trigger: 'blur'},
                ]
            },
            addDialogVisible: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [2, 4], '会员说明')
        this.init()
    },
    components: {},
    methods: {
        //  页面加载时请求
        async init() {
            this.loading = true
            let _data = await getMemberClassifyList()
            this.lists = _data.data
            this.loading = false
        },
        addClassify(item) {
            if (item) {
                this.cur_id = item.typeId
                this.ruleForm.name = item.typeName
            } else {
                this.ruleForm.name = ''
                this.cur_id = ''
            }
            this.addDialogVisible = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitChange(formName)
                }
            });
        },
        async submitChange(formName) {
            this.loading = true
            let _data = await createAndUpdateArticleType(this.cur_id, this.ruleForm.name)
            this.loading = false
            if (_data.status === 200) {
                if (this.cur_id) {
                    this.$message.success('保存成功')
                } else {
                    this.$message.success('提交成功')
                }
                this.addDialogVisible = false
                this.$refs[formName].resetFields()
                await this.init()
            } else {
                this.$message.error(_data.msg)
            }
        },
        deleteItem(id) {
            this.$confirm("您确定要删除该分类及分类下的说明吗", "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delPosition(id)
            })
        },
        async delPosition(id) {
            let _data = await delArticleType(id)
            if (_data.status === 200) {
                this.$message.success(_data.msg)
                await this.init()
            } else {
                this.$message.error(_data.msg)
            }
        },
        deleteArticleItem(id) {
            this.$confirm("您确定要删除该说明吗", "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delArticlePosition(id)
            })
        },
        async delArticlePosition(id) {
            let _data = await delArticle(id)
            if (_data.status === 200) {
                this.$message.success(_data.msg)
                await this.init()
            } else {
                this.$message.error(_data.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .page-list {
        .item {
            width: 100%;
            border: solid 1px #e8e8e8;

            .header {
                height: 68px;
                background-color: #f4f4f4;
                border-bottom: solid 1px #e8e8e8;

                .title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;

                    i {
                        font-size: 20px;
                        color: #0a2240;
                        margin-right: 10px;
                    }
                }
            }

            .child {
                height: 68px;
                background-color: #ffffff;
                padding: 0 28px;
                border-bottom: 1px solid #f6f6f6;
                .title {
                    font-size: 14px;
                    padding-left: 65px;
                    color: #333333;
                }
            }

            .sort {
                font-size: 14px;
                color: #0a2240;

                span {
                    background-color: #ffffff;
                    border-radius: 6px;
                    border: solid 1px #e8e8e8;
                    font-size: 14px;
                    color: #999999;
                    padding: 10px 15px;
                }
            }

            .operate {
                width: 60px;
                height: 34px;
                border-radius: 20px;
                border: solid 1px #0a2240;
                font-size: 14px;
                padding: 0;
                background-color: #0a2240;
                color: #ffffff;

                &.line {
                    background-color: #ffffff;
                    color: #0a2240;
                }

                &.active {
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#29c16d, #29c16d);
                    background-blend-mode: normal, normal;
                    border: none;
                }
            }
        }
    }

    .input-container {
        .el-select {
            width: 100%;
        }
    }
}
</style>